import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface NewsContents {
  name: string;
  api_token: string;
}

export interface NewsContentsListInfor {
  errors: unknown;
  newsContents: NewsContents;
  isAuthenticated: boolean;
}

@Module
export default class NewsContentsModule
  extends VuexModule
  implements NewsContentsListInfor
{
  errors = {};
  newsContents = {} as NewsContents;
  isAuthenticated = !!JwtService.getToken();

  get NewsContents() {
    return this.newsContentsListData;
  }

  @Mutation
  [Mutations.NEWS_CONTENTS_LIST_DATA](NewsContent) {
    this.newsContentsListData = NewsContent;
  }

  @Action
  [Actions.NEWS_CONTENTS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/news", payload)
        .then((data) => {
          this.context.commit(Mutations.NEWS_CONTENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.NEWS_CONTENT_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("news/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.NEWS_CONTENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.NEWS_CONTENT_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/news", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.NEWS_CONTENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.NEWS_CONTENT_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/news", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.NEWS_CONTENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.NEWS_CONTENT_UPDATE_STATUS](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/news/${payload.id}/update-status`, payload)
        .then((data) => {
          this.context.commit(Mutations.NEWS_CONTENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.NEWS_CONTENT_SET_MENU](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/news/${payload.id}/set-menu`, payload)
        .then((data) => {
          this.context.commit(Mutations.NEWS_CONTENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
